<template lang="pug">
  .close-modal-icon
    inline-svg(:src="require('./close.svg')" width="21" height="21")
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator";
import InlineSvg from 'vue-inline-svg';

@Component({
  name: "CloseModalIcon",
  components: {InlineSvg}
})
export default class CloseModalIcon extends Vue {

}
</script>

<style scoped lang="less">
.close-modal-icon {
  display: block;
  width: 21px;
  height: 21px;
  cursor: pointer;
  cursor: hand;
}
</style>
